<template>
    <div class="modal-dialog" v-if="showModal">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">Eliminar Patrón</h4>
                <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p>¿Estás seguro que deseas eliminar el patrón seleccionado?</p>
                <p style="font-weight: bold;">{{ employer.name }}</p>
            </div>
            <div class="modal-footer">
                <button class="btn btn-danger btn-sm" type="button" style="float: right;" @click="deleteEmployerValidation">Confirmar</button>
            </div>
        </div>
    </div>
</template>
<script>

import ws from '@/services/employers'

import validations from "@/mixins/validations/employerValidations";
import modalCleanupMixin from '@/mixins/commen/modalCleanupMixin';

export default {
    name: 'delete_employer_modal',
    mixins: [validations, modalCleanupMixin],
    components: {
        
    },
    props: {

    },
    data(){
        return{
            showModal: true,
            employer: false
        }
    },
    methods: {
        setEmployer(data){
            this.employer = data;
            this.setForm(data);

            this.showModal = true;
        },
        async deleteEmployer(form) {
            let response = await ws.deleteEmployer(form);

            if(response.type == "success"){
                this.$toast.success(response.message);
                
                this.showModal = false;
            
                this.closeModal();

                this.$emit("delete", response.data );
            }
            else{
                this.$toast.error(response.message);
            }
        },
    }
}
</script>